import * as React from "react";
import { Dispatch, connect } from "react-redux";
import { IApplicationState, AppActionCreators, ITicketingState, TicketingActionCreators, ICenterState, IAppState, ITicketLookupDataResponse, ContactActionCreators, ITicketResponse, ICannedResponseListResponse } from "@nkr/store/index";
import { IContactListResponse, ISelectItem, ITicketRequest, IEditorValue } from "@nkr/models/index";
import { TicketEntityType, TicketType, CannedResponseAvailability } from "@nkr/enums/index";
import { Button, FormGroup, ControlLabel, FormControl, Checkbox, Alert, Col, Glyphicon } from "react-bootstrap";
import Select, { OptionsType } from 'react-select'
import { DropdownIndicator } from '../../dropdown-indicator';
import AsyncCreatable from 'react-select/async-creatable';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import MyUploader from '../../file-upload';
import { LinkButtonWrapper } from "../../styles";
import JoditEditor from '@nkr/components/editor';
import config from '../../jodit-editor-config';
import { INewContactValidation } from "./new-contact-validation";
import NewContact from "./new-contact";
import { toast } from "react-toastify";
import { helpers } from "../helpers";
import { debounce } from "lodash";
import Drawer from "rc-drawer";
import CannedResponses from "../../canned-responses";

interface IProps {
    centerId?: number
}

interface IStateProps {
    app: IAppState,
    ticketing: ITicketingState,
    centers: ICenterState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<ITicketLookupDataResponse>,
    getContacts: (search: string) => Promise<IContactListResponse>,
    getCannedResponses: () => Promise<ICannedResponseListResponse>
    saveTicket: (newTicket: ITicketRequest) => Promise<ITicketResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IValidation {
    createNew: INewContactValidation,
    to: boolean,
    subject: boolean,
    description: boolean
    status: boolean,
    tier: boolean,
    urgency: boolean
}

interface IState {
    fromList: ISelectItem[],
    from: ISelectItem,
    to: ISelectItem,
    createNew: {
        show: boolean,
        firstName: string,
        lastName: string,
        email: string,
        phoneNumber: string
    },
    showCc: boolean,
    cc: ISelectItem[],
    subject: string,
    description: string,
    files: File[],
    status: number,
    center: number,
    tier: number,
    ticketType: number,
    urgency: number,
    tags: ISelectItem[],
    validation: IValidation,
    dirty: boolean,
    sendAnother: boolean,
    showCannedResponses: boolean
}

class NewEmail extends React.Component<TProps, IState> {
    initialState: IState = {
        fromList: helpers.getFromList(this.props.app.user.firstName, this.props.app.user.lastName, this.props.app.user.username, this.props.app.user.email),
        from: helpers.getFromList(this.props.app.user.firstName, this.props.app.user.lastName, this.props.app.user.username, this.props.app.user.email)[0],
        to: __ENVIRONMENT__ == 'dev2' ? { value: '4846', label: 'Steve J (spoiledheeb@gmail.com)', email: 'spoiledheeb@gmail' } : null,
        createNew: {
            show: false,
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: ''
        },
        showCc: false,
        cc: [],
        subject: __ENVIRONMENT__ == 'dev2' ? 'email test' : '',
        description: __ENVIRONMENT__ == 'dev2' ? '<span>hope this works</span>' : '',
        files: [],
        status: 1,
        center: 0,
        tier: __ENVIRONMENT__ == 'dev2' ? 0 : -1,
        ticketType: TicketType.GeneralRequest,
        urgency: -1,
        tags: [],
        validation: {
            createNew: {
                firstName: true,
                lastName: true,
                email: true,
                phoneNumber: true,
            },
            to: true,
            subject: true,
            description: true,
            status: true,
            tier: true,
            urgency: true
        },
        dirty: false,
        sendAnother: false,
        showCannedResponses: false
    }

    readonly state = this.initialState;

    private container: HTMLDivElement;

    componentDidMount = () => {
        this.getData();
    }

    handleDropDownChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let state = { ...this.state };
        let id = e.currentTarget.id;

        state[id] = parseInt(e.currentTarget.value);

        this.setState(state);
    }

    handleFromChange = (from: ISelectItem) => {
        this.setState({
            from
        });
    }

    handleToChange = (list: ISelectItem) => {
        this.setState({
            to: list
        });
    }

    handleCreateNew = () => {
        this.setState({
            createNew: { ...this.state.createNew, show: true }
        });
    }

    handleNewContactDataChange = (value: string, property: string) => {
        this.setState({
            createNew: { ...this.state.createNew, [property]: value }
        });
    }

    handleCancelCreateNew = () => {
        this.setState({
            createNew: { ...this.state.createNew, show: false }
        });
    }

    handleShowCc = () => {
        this.setState({
            showCc: !this.state.showCc
        });
    }

    handleCcChange = (list: ISelectItem[]) => {
        list = list.map(item => {
            if (item.email == undefined)
                item.email = item.value;

            return item;
        });

        this.setState({
            cc: list
        });
    }

    handleSubjectChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.subject = e.currentTarget.value != '';

        this.setState({
            subject: e.currentTarget.value,
            validation
        });
    }

    handleDescriptionChange = (e: any) => {
        this.setState({
            description: e
        });
    }

    handleTagsChange = (list: ISelectItem[]) => {
        this.setState({
            tags: list
        });
    }

    handleFilesChanged = (file: File, status: string) => {
        let files = [...this.state.files];

        if (status == 'done') {
            files.push(file);
        }

        if (status == 'removed') {
            files = files.filter(x => x.name == file.name);
        }

        this.setState({
            files
        });
    }

    handleSendAnotherChange = (e: React.FormEvent<Checkbox & HTMLInputElement>) => {
        this.setState({
            sendAnother: e.currentTarget.checked
        });
    }

    handleSend = () => {
        this.send();
    }

    handleCancel = () => {
        window.location.href = '/ticketing/tickets';
    }

    handleShowCannedResponses = () => {
        this.setState({
            showCannedResponses: true
        });
    }

    handleCloseCannedResponses = () => {
        this.setState({
            showCannedResponses: false
        });
    }

    handleApplyCannedResponse = (id: number) => {
        let selectedCannedResponse = this.props.ticketing.cannedResponses.find(x => x.id == id);

        this.setState({
            showCannedResponses: false,
            description: selectedCannedResponse.message
        });
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    getData = () => {
        this.props.showLoading("Getting things ready, one moment please...").then(() => {
            return Promise.all([
                this.props.getLookupData(),
                this.props.getCannedResponses()
            ]).then(() => {
                this.props.hideLoading();
            });
        });
    }

    loadContactOptions = debounce((search: string, callback: ((options: OptionsType<any>) => void)) => {
        if (search.length >= 3) {
            this.props.getContacts(search)
                .then(response => {
                    if (response.data.success) {
                        let results = response.data.results.map(x => { return { value: x.id, label: `${x.fullName} (${x.email})`, email: x.email }; });
                        callback(results);
                    }
                })
                .catch((error) => {
                    callback(error);
                });
        } else {
            callback([]);
        }
    }, 500)

    validate = () => {
        let { to, createNew, subject, description, status, tier, urgency } = this.state;
        let { show, firstName, lastName, email, phoneNumber } = createNew;

        let validation: IValidation = {
            to: createNew.show ? true : to != null,
            createNew: {
                firstName: show ? firstName != '' : true,
                lastName: show ? lastName != '' : true,
                email: show ? email != '' : true,
                phoneNumber: show ? phoneNumber != '' : true
            },
            subject: subject != '',
            description: description != '',
            status: status > 0,
            tier: tier >= 0,
            urgency: urgency >= 0
        };

        let isCreateNewValid = show ? firstName && lastName && email : true;
        let isValid = validation.to && isCreateNewValid && validation.subject && validation.status && validation.urgency && validation.description;

        return { validation, isValid };
    }

    send = () => {
        let validationResults = this.validate();

        this.setState({
            validation: validationResults.validation,
            dirty: true
        }, () => {
            if (validationResults.isValid) {
                let { from, to, createNew, cc, subject, description, status, ticketType, tier, urgency, tags, files, center } = this.state;

                var newTicket: ITicketRequest = {
                    id: 0,
                    fromEmail: from.email,
                    contactId: to != null ? parseInt(to.value) : null,
                    cc: cc.map(x => x.email),
                    subject,
                    description,
                    firstName: createNew.show ? createNew.firstName : '',
                    lastName: createNew.show ? createNew.lastName : '',
                    email: createNew.show ? createNew.email : '',
                    phoneNumber: createNew.show ? createNew.phoneNumber : '',
                    groupId: 0,
                    assignedUserId: 0,
                    entityType: center > 0 ? TicketEntityType.Center : null,
                    entityTypeId: center > 0 ? center : null,
                    ticketStatusId: status,
                    ticketTypeId: ticketType,
                    tierLevelId: tier,
                    urgency,
                    isEmail: true,
                    tags: tags.map(x => x.label),
                    files
                };

                this.props.showLoading('Saving ticket, one moment please...').then(() => {
                    this.props.saveTicket(newTicket).then(response => {
                        this.props.hideLoading();

                        if (response.data.success) {
                            if (this.state.sendAnother) {
                                toast.success('Email sent successfully');
                                this.setState(this.initialState);
                            } else {
                                toast.success('Email sent successfully', {
                                    onClose: () => {
                                        window.location.href = '/ticketing/tickets';
                                    }
                                });
                            }
                        }
                    });
                });
            } else {
                window.scrollTo(0, 0);
            }
        });
    }

    render = () => {
        const validationResults = this.validate();
        const toSuggestions = [];
        const tagSuggestions = [];

        const centerList = this.state.ticketType == TicketType.MemberCenterRequest ?
            this.props.ticketing.lookupData.centerList.filter(x => x.isMemberCenter)
            :
            this.props.ticketing.lookupData.centerList.filter(x => x.isMemberCenter == false);

        const cannedResponses = this.props.ticketing.cannedResponses.filter(x => {
            return x.availability == CannedResponseAvailability.AllAgents || (x.availability == CannedResponseAvailability.Myself && x.ownerId == this.props.app.user.id);
        });

        return (
            <>
                <div ref={this.saveContainer} />
                <div className="container" style={{ paddingBottom: 20 }}>
                    {this.state.dirty && !validationResults.isValid && (
                        <div className="row">
                            <Col xs={12} lg={12}>
                                <Alert bsStyle="danger">
                                    The following issues were found:
                                    <ul>
                                        {!validationResults.validation.to && (
                                            <li>To is required</li>
                                        )}

                                        {!validationResults.validation.createNew.firstName && (
                                            <li>First name is required</li>
                                        )}

                                        {!validationResults.validation.createNew.lastName && (
                                            <li>Last name is required</li>
                                        )}

                                        {!validationResults.validation.createNew.email && (
                                            <li>Email is required</li>
                                        )}

                                        {!validationResults.validation.subject && (
                                            <li>Subject is required</li>
                                        )}

                                        {!validationResults.validation.description && (
                                            <li>Description is required</li>
                                        )}

                                        {!validationResults.validation.status && (
                                            <li>Status is required</li>
                                        )}

                                        {!validationResults.validation.urgency && (
                                            <li>Urgency is required</li>
                                        )}

                                        {!validationResults.validation.tier && (
                                            <li>Tier is required</li>
                                        )}
                                    </ul>
                                </Alert>
                            </Col>
                        </div>
                    )}

                    <div className="row">
                        <div className="col-xs-12 col-lg-12">
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div>
                                    <h1 style={{ marginBottom: 30 }}>Send an Email</h1>
                                </div>
                                <div>
                                    <a className="btn btn-link" href="/ticketing/tickets">Return to List</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12 col-lg-12">
                            <FormGroup>
                                <ControlLabel>From</ControlLabel>
                                <Select
                                    isSearchable={false}
                                    styles={{
                                        indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                        dropdownIndicator: defaultStyles => ({
                                            ...defaultStyles,
                                            color: 'black'
                                        }),
                                        menu: defaultStyles => ({
                                            ...defaultStyles,
                                            zIndex: 99999
                                        }),
                                    }}
                                    components={{ DropdownIndicator }}
                                    options={this.state.fromList}
                                    value={this.state.from}
                                    onChange={this.handleFromChange}
                                />
                            </FormGroup>

                            {!this.state.createNew.show ?
                                <FormGroup style={{ marginBottom: 0 }} validationState={!this.state.validation.to ? 'error' : null}>
                                    <ControlLabel>To</ControlLabel>
                                    <AsyncSelect
                                        value={this.state.to}
                                        loadOptions={this.loadContactOptions}
                                        components={{ DropdownIndicator }}
                                        styles={{
                                            indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                            dropdownIndicator: defaultStyles => ({
                                                ...defaultStyles,
                                                color: 'black'
                                            }),
                                            menu: defaultStyles => ({
                                                ...defaultStyles,
                                                zIndex: 99999
                                            }),
                                        }}
                                        onChange={this.handleToChange}
                                    />
                                    <div className='text-right'>
                                        <LinkButtonWrapper bsStyle="link" onClick={this.handleCreateNew}>Add New Contact</LinkButtonWrapper>

                                        {!this.state.showCc && (
                                            <>
                                                &nbsp;|&nbsp;
                                                <LinkButtonWrapper bsStyle="link" onClick={this.handleShowCc}>Add Cc</LinkButtonWrapper>
                                            </>
                                        )}
                                    </div>
                                </FormGroup>
                                :
                                <NewContact
                                    data={this.state.createNew}
                                    validation={this.state.validation.createNew}
                                    onDataChange={this.handleNewContactDataChange}
                                    onCancel={this.handleCancelCreateNew}
                                />
                            }

                            {this.state.showCc && (
                                <FormGroup style={{ marginBottom: 0 }}>
                                    <ControlLabel>Cc</ControlLabel>
                                    <AsyncCreatable
                                        value={this.state.cc}
                                        loadOptions={this.loadContactOptions}
                                        components={{ DropdownIndicator }}
                                        styles={{
                                            indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                            dropdownIndicator: defaultStyles => ({
                                                ...defaultStyles,
                                                color: 'black'
                                            }),
                                            menu: defaultStyles => ({
                                                ...defaultStyles,
                                                zIndex: 99999
                                            }),
                                        }}
                                        isClearable={true}
                                        isMulti={true}
                                        onChange={this.handleCcChange}
                                    />
                                    <div className='text-right'>
                                        <LinkButtonWrapper bsStyle='link' onClick={this.handleShowCc}>Hide Cc</LinkButtonWrapper>
                                    </div>
                                </FormGroup>
                            )}

                            <FormGroup validationState={!this.state.validation.subject ? "error" : null}>
                                <ControlLabel>Subject</ControlLabel>
                                <FormControl
                                    value={this.state.subject}
                                    onChange={this.handleSubjectChange}
                                />
                            </FormGroup>

                            <FormGroup validationState={!this.state.validation.description ? "error" : null}>
                                <ControlLabel>Description</ControlLabel>
                                <JoditEditor
                                    value={this.state.description}
                                    config={config}
                                    onChange={this.handleDescriptionChange}
                                    onBlur={() => null}
                                />

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 5 }}>
                                    <div>
                                        <Button bsSize='xs' title='Canned Responses' onClick={this.handleShowCannedResponses}><Glyphicon glyph='comment' /></Button>
                                    </div>
                                    <div>
                                        <MyUploader filesChanged={this.handleFilesChanged} />
                                    </div>
                                </div>
                            </FormGroup>

                            <FormGroup validationState={!this.state.validation.status ? "error" : null}>
                                <ControlLabel>Status</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    id="status"
                                    value={this.state.status}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={0}>- Select Status -</option>
                                    {this.props.ticketing.lookupData.ticketStatusList.map((item) =>
                                        <option value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Request Type</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    id="ticketType"
                                    value={this.state.ticketType}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={-1}>- Select Type -</option>
                                    {this.props.ticketing.lookupData.ticketTypeList.map((item) =>
                                        <option value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            {(this.state.ticketType == TicketType.MemberCenterRequest || this.state.ticketType == TicketType.ContactPageNonMemberCenter) && (
                                <FormGroup>
                                    <ControlLabel><ControlLabel>{this.state.ticketType == TicketType.MemberCenterRequest ? 'Member Center' : 'Non-member Center'}</ControlLabel></ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        id="center"
                                        value={this.state.center}
                                        onChange={this.handleDropDownChange}
                                    >
                                        <option value={0}>- Select Center -</option>
                                        {centerList.map((item) =>
                                            <option value={item.id}>{item.alias}</option>
                                        )}
                                    </FormControl>
                                </FormGroup>
                            )}

                            <FormGroup validationState={!this.state.validation.tier ? "error" : null}>
                                <ControlLabel>Tier Level</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    id="tier"
                                    value={this.state.tier}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={-1}>- Select Tier Level -</option>
                                    {this.props.ticketing.lookupData.ticketTierList.map((item) =>
                                        <option value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup validationState={!this.state.validation.urgency ? "error" : null}>
                                <ControlLabel>Urgency</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    id="urgency"
                                    value={this.state.urgency}
                                    onChange={this.handleDropDownChange}
                                >
                                    <option value={-1}>- Select Urgency -</option>
                                    {this.props.ticketing.lookupData.ticketUrgencyList.map((item) =>
                                        <option value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Tags</ControlLabel>
                                <CreatableSelect
                                    defaultValue={[]}
                                    value={this.state.tags}
                                    isMulti
                                    name="tags"
                                    options={tagSuggestions}
                                    components={{ DropdownIndicator }}
                                    styles={{
                                        indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                        dropdownIndicator: defaultStyles => ({
                                            ...defaultStyles,
                                            color: 'black'
                                        }),
                                        multiValueLabel: (styles, { data }) => ({
                                            ...styles,
                                            backgroundColor: 'pink'
                                        }),
                                        multiValueRemove: (styles, { data }) => ({
                                            ...styles,
                                            backgroundColor: 'pink'
                                        }),
                                    }}
                                    onChange={this.handleTagsChange}
                                />
                            </FormGroup>

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <Checkbox checked={this.state.sendAnother} onChange={this.handleSendAnotherChange}>Send another</Checkbox>
                                </div>
                                <div>
                                    <Button bsStyle="primary" bsSize="large" style={{ marginRight: 5 }} onClick={this.handleSend}>Send</Button>
                                    <Button bsStyle="link" onClick={this.handleCancel}>Cancel &amp; return to the list</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Drawer
                    width="20vw"
                    // handler={false}
                    placement="right"
                    getContainer={this.getContainer}
                    open={this.state.showCannedResponses}
                >
                    <CannedResponses
                        cannedResponses={cannedResponses}
                        onApply={this.handleApplyCannedResponse}
                        onClose={this.handleCloseCannedResponses}
                    />
                </Drawer>
            </>
        )
    };
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        ticketing: state.ticketing,
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch<any>(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch<any>(AppActionCreators.hideLoading());
        },
        getLookupData: () => {
            return dispatch<any>(TicketingActionCreators.getLookupData());
        },
        getContacts: (search) => {
            return dispatch<any>(ContactActionCreators.getContacts(search));
        },
        getCannedResponses: () => {
            return dispatch(TicketingActionCreators.getCannedResponses());
        },
        saveTicket: (newTicket) => {
            return dispatch<any>(TicketingActionCreators.saveTicket(newTicket));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(NewEmail);